import { users, assets } from './client'

export default {
	users,
	assets
}
